<template>
	<div class="equipment">
		<div class="leftContent">
			<!--设备-->
			<div class="modelClass">设备型号：{{rowObj.model}}</div>
			<div class="setNameClass">{{String(rowObj.name).replace(/\s/g,"&ensp;")}}</div>
			<div class="typeClass">{{urlValue}}/{{String(rowObj.name).replace(/\s/g,"&ensp;")}}</div>
		</div>
		<div class="rightContent">
			<div class="modelClass" v-if="boxShow">设备类型：{{deviceType}}</div>
			<div class="setNameClass" v-if="boxShow">通讯地址：{{deviceAddr}}</div>
			<div class="setNameClass" v-if="boxShow">设备编号：{{deviceCode}}</div>
			<div class="typeClass2" v-if="boxShow"><span>设备型号：{{deviceModel}}</span>
				<el-button type="primary" @click="relationClick('编辑网关')" class="relationButton3" v-if="boxShow">编辑监测设备</el-button>
				<el-button type="primary" @click="relationClick()" class="relationButton">关联监测设备</el-button>
			</div>
			<el-button type="primary" @click="relationClick()" class="relationButton2" v-if="!boxShow">关联监测设备</el-button>
		</div>
		<div class="userBox">
			<i class="iconfont icon-yonghu1 userIconClass"></i>
			<span class="createManger">创建人：{{nameValue}}</span>
			<span class="createTime">创建时间：{{createTime}}</span>
		</div>
		<div class="tooltipClass" v-if="!boxShow">
			<i class="iconfont icon-duihao successBox"></i>
			<span>该设备还未完成链接设备，找您的供应商完成设备</span>
			<p>设备型号：12864015702</p>
		</div>

		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<!--弹窗1关联网关设备-->
		<div class="specilDialog">
			<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
				<el-form>
					<div class="itemClass">
						<el-form-item label="监测设备类型" label-width="25%">
							<el-select v-model="category_id" placeholder="请选择" style="width:100%" @change="categoryChange()">
								<el-option v-for="item in categoryData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="监测设备型号" label-width="25%">
							<el-select v-model="product_id" placeholder="请选择" style="width:100%" @change="modelChange()">
								<el-option v-for="item in projectData" :key="item.id" :label="item.model" :value="item.id">
								</el-option>
							</el-select>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="通讯地址" label-width="25%">
							<el-input type="text" v-model="addr" autocomplete="off"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		//解决相同路由不刷新的问题
		watch: {
			$route(to, from) {
				if(this.$route.query.id) {
					this.equipmentId = this.$route.query.id
					this.getById() ///获取当前子项目列表

					window.addEventListener('resize', () => {
						if(document.body.clientWidth < 767) {
							this.dialogWidth = "100%"
						} else if(document.body.clientWidth < 1200) {
							this.dialogWidth = "64%"
						} else {
							this.dialogWidth = "36%"
						}
					})
				}
			}
		},
		mounted() {
			this.equipmentId = this.$route.query.id
			this.getById(); //获取当前子项目列表
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "36%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "36%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				categoryData: [], //分类列表
				projectData: [], //产品列表(某分类类型里的)
				projectDataAll: [], //产品列表(所有)
				productObj: {}, //选中的产品对象
				dialogFormVisible: false,
				title: '', //弹窗标题
				dialogWidth: '36%', //dialog的宽度
				equipmentId: '', //网关id
				rowObj: {}, //网关对象列表
				/*基础信息*/
				urlValue: '', //面包屑
				createTime: '', //创建时间
				nameValue: '', //创建人
				deviceAddr: '', //通信地址
				deviceCode: '', //code
				deviceType: '', //设备类型
				deviceModel: '', //设备型号
				deviceType_id: '', //设备类型id
				deviceModel_id: '', //设备型号id
				uid_Sign: '', //设备录入uid的更新
				/*表单*/
				product_id: '', //检测型号
				category_id: '', //分类id
				addr: '', //通讯地址
				boxShow: false, //是否显示
				device_id: '', //设备的id
				notDo: false, //不执行开关

			}
		},
		methods: {
			//获取当前子项目列表
			getById() {
				var params = {}
				let config = headers.headers(this.equipmentId)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/' + this.equipmentId, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowObj = res.data
						this.deviceType_id = this.rowObj.category_id
						this.deviceModel_id = this.rowObj.product_id
						this.geProduct(); //获取所有产品列表
						this.getCmannger(); //c_manger列表
						this.getPath(); //获取面包屑导航路径
						this.getCategory(); //获取分类列表
						this.getDevice(); //设备列表
					} else {
						this.rowObj = {}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
			},
			//设备列表
			getDevice() {
				var params = {
					subproject_id: this.rowObj.id
				}
				//console.log(params)
				let config = headers.headers('getBySubproject')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/device/getBySubproject', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.boxShow = true
						this.deviceAddr = res.data.addr //通讯地址
						this.device_id = res.data.id
						this.deviceCode = res.data.code
					} else {
						this.boxShow = false
						this.deviceAddr = ''
						this.device_id = ''
						this.deviceCode = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取分类列表
			getCategory() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.categoryData = res.data
						this.categoryData.forEach(item => {
							if(this.deviceType_id) {
								if(item.id == this.deviceType_id) {
									this.deviceType = item.name
								}
							} else {
								this.deviceType = ''
							}
						})

					} else {
						this.categoryData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取产品列表
			geProduct() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(this.deviceModel_id) {
								if(item.id == this.deviceModel_id) {
									this.deviceModel = item.model
								}
							} else {
								this.deviceModel = ''
							}
						})
						this.projectData = res.data
					} else {
						this.projectData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//分类的改变
			categoryChange() {
				this.product_id = ''
				//获取产品列表
				var params = {
					pageSize: -1,
					pageIndex: 1,
					category_id: this.category_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/product/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectData = res.data
					} else {
						this.projectData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取面包屑导航路径
			getPath() {
				var params = {
					id: this.equipmentId
				}
				let config = headers.headers('getPath')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/getPath', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.urlValue = res.data
					} else {
						this.urlValue = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取c端manger用户名
			getCmannger() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c_manager/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.id == this.rowObj.c_manager_id) {
								this.createTime = item.create_time
								this.nameValue = item.username
							}
						})
					} else {
						this.nameValue = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//关联监测设备
			relationClick(val) {
				this.uid_Sign = val
				if(this.uid_Sign) {
					this.title = "编辑设备"
				} else {
					this.title = "新增设备"
				}
				this.dialogFormVisible = true
				if(this.boxShow) { //编辑
					this.category_id = this.rowObj.category_id
					this.categoryChange();
					this.product_id = this.rowObj.product_id
					//console.log(this.product_id)
					this.addr = this.deviceAddr
				} else { //添加

					this.category_id = ''
					this.product_id = ''
					this.addr = ''
				}
			},
			//监测设备型号的改变
			modelChange() {
				//根据产品id获取产品列表
				this.projectData.forEach(item => {
					if(item.id == this.product_id) {
						this.productObj = item
					}
				})
			},
			save() {
				this.childSave();
				this.finalSave();
			},
			//子项目更新保存
			childSave() {
				if(this.uid_Sign) {
					var params = { //更新
						id: this.rowObj.id,
						product_id: this.product_id,
						category_id: this.category_id,
						status: 1,
						version: 0,
					}
				} else {
					var params = { //更新
						id: this.rowObj.id,
						product_id: this.product_id,
						category_id: this.category_id,
						code: this.$uuid.v1(),
						status: 1,
						version: 0,
					}
				}
				var timestamp = Date.parse(new Date());
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					axios.post(this.http + '/zkep2/subproject/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getById();
							this.deviceType_id = this.category_id
							this.deviceModel_id = this.product_id
							this.geProduct()
							this.getCategory()
							//this.dialogFormVisible = false
						} else {
							this.$message('操作失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//设备的保存
			finalSave() {
				/*创建时间的处理*/
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				if(this.boxShow) { //编辑
					var params = {
						id: this.device_id,
						c_id: this.rowObj.c_id, //所属C端客户
						subproject_id: this.equipmentId, //所关联子项目
						gateway_id: 0, //所属网关
						name: this.addr, //名称
						ruler_type: this.productObj.ruler_type, //规约类型
						password: this.productObj.password, //通信密码
						fee_num: this.productObj.fee_num, //费率个数
						user_type: this.productObj.user_type, //用户类型
						rate_type: this.productObj.rate_type, //波特率
						join_type: this.productObj.join_type, //接线方式
						rated_v: this.productObj.rated_v, //额定电压
						rated_a: this.productObj.rated_a, //额定电流
						port: '', //端口
						rate_v: 1, //电压变比 
						rate_a: 1, //电流变比
						addr: this.addr, //通讯地址	
						use_status: 0, //设备状态
						status: 1,
						create_time: timestamp,
						version: 0
					}
				} else { //添加
					var params = {
						src: 1,
						c_id: this.rowObj.c_id, //所属C端客户
						manager_id: manager_id,
						subproject_id: this.equipmentId, //所关联子项目
						gateway_id: 0, //所属网关
						name: this.addr, //名称
						ruler_type: this.productObj.ruler_type, //规约类型
						password: this.productObj.password, //通信密码
						fee_num: this.productObj.fee_num, //费率个数
						user_type: this.productObj.user_type, //用户类型
						rate_type: this.productObj.rate_type, //波特率
						join_type: this.productObj.join_type, //接线方式
						rated_v: this.productObj.rated_v, //额定电压
						rated_a: this.productObj.rated_a, //额定电流
						port: '', //端口
						rate_v: 1, //电压变比 
						rate_a: 1, //电流变比
						addr: this.addr, //通讯地址	
						use_status: 0, //设备状态
						create_time: timestamp,
						status: 1,
						version: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					if(this.addr) {
						axios.post(this.http + '/zkep2/device/save',
							qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.boxShow = true
								this.dialogFormVisible = false
								this.getDevice();
							} else {
								this.$message('新增失败！');
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$message('请输入必填项！');
					}
				}
			},
			//通讯地址的更改//TODO
			addrChange() {
				var params = {
					code: this.addr
				}
				let config = headers.headers('getByCode')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/subproject/getByCode', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.boxShow && this.addr == this.deviceAddr) {
							this.notDo = false
							return
						}
						this.notDo = true
						this.$message('该通讯地址已存在,请重新输入通讯地址！');
						this.addr = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style>
	.equipment {
		height: 100%;
		padding: 1% 0 0 1%;
		position: relative;
		font-size: 13px;
		min-width: 700px;
	}
	
	.equipment .leftContent,
	.equipment .rightContent {
		display: inline-block;
		width: 49.5%;
		height: 156px;
		background-color: #fff;
		border-radius: 2px;
		margin-right: 0.5%;
		vertical-align: top;
	}
	
	.equipment .modelClass {
		margin: 2% 0 4% 3%;
		color: #808080;
	}
	
	.equipment .setNameClass {
		font-size: 14px;
		font-weight: 600;
		margin-left: 3%;
	}
	
	.equipment .typeClass {
		position: relative;
		margin: 6% 0 3% 3%;
		color: #808080;
	}
	
	.equipment .typeClass2 {
		position: relative;
		margin: 2.5% 0 3% 3%;
		color: #808080;
	}
	
	.equipment .rightContent {
		position: relative;
		margin-right: 0;
	}
	
	.equipment .relationButton {
		position: absolute;
		bottom: 0;
		right: 7px;
		padding: 4px 14px;
		font-size: 12px;
	}
	
	.equipment .relationButton3 {
		position: absolute;
		bottom: 0;
		right: 130px;
		padding: 4px 14px;
		font-size: 12px;
	}
	
	.equipment .relationButton2 {
		position: absolute;
		bottom: 10px;
		right: 7px;
		padding: 4px 14px;
		font-size: 12px;
	}
	
	.equipment .userBox {
		position: relative;
		margin-top: 10px;
		height: 90px;
		width: 360px;
		background-color: #fff;
		border-radius: 2px;
	}
	
	.equipment .userIconClass {
		position: absolute;
		top: 30%;
		left: 6%;
		font-size: 32px;
		font-weight: bold;
		color: #439DFD;
	}
	
	.equipment .createManger {
		position: absolute;
		top: 22%;
		left: 20%;
		font-size: 14px;
	}
	
	.equipment .createTime {
		position: absolute;
		bottom: 22%;
		left: 20%;
		display: inline-block;
		color: #808080;
	}
	
	.equipment .tooltipClass {
		margin-top: 40px;
		height: 80px;
		line-height: 20px;
		text-align: center;
		color: #C0C0C0;
	}
	
	.equipment .successBox {
		vertical-align: bottom;
		display: inline-block;
		color: #A9E58D;
		font-size: 19px;
	}
	
	.equipment .successBox span {
		vertical-align: top;
	}
	
	.equipment .el-dialog__title {
		color: #999;
	}
	
	.equipment .el-dialog__footer {
		text-align: center;
	}
	
	.equipment .pagination {
		text-align: center;
	}
	
	.equipment .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.equipment .itemClass {
		position: relative;
	}
	
	.equipment .specilDialog .el-dialog__body {
		padding-right: 50px;
	}
	
	.equipment .xinghaoClass {
		position: absolute;
		top: 0;
		right: -30px;
		font-size: 12px;
		color: #969896;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/Equipment.vue